var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2133_24723)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2133_24723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.09891 6.11211C5.20105 6.11211 5.28672 6.07428 5.35593 5.99863C5.42514 5.92297 5.45963 5.82945 5.45939 5.71806C5.45939 5.60642 5.42478 5.5129 5.35557 5.4375C5.28636 5.36211 5.20081 5.32428 5.09891 5.32402C4.99678 5.32402 4.91122 5.36185 4.84225 5.4375C4.77328 5.51316 4.73867 5.60668 4.73843 5.71806C4.73843 5.82971 4.77304 5.92336 4.84225 5.99902C4.91146 6.07468 4.99702 6.11237 5.09891 6.11211ZM5.09891 4.53592C5.20105 4.53592 5.28672 4.4981 5.35593 4.42244C5.42514 4.34678 5.45963 4.25326 5.45939 4.14188V2.56569C5.45939 2.45404 5.42478 2.36052 5.35557 2.28513C5.28636 2.20973 5.20081 2.17191 5.09891 2.17164C4.99678 2.17164 4.91122 2.20947 4.84225 2.28513C4.77328 2.36079 4.73867 2.45431 4.73843 2.56569V4.14188C4.73843 4.25352 4.77304 4.34718 4.84225 4.42283C4.91146 4.49849 4.99702 4.53619 5.09891 4.53592ZM2.93605 7.29425L2.10695 8.20056C1.9928 8.32534 1.86207 8.35332 1.71475 8.28449C1.56744 8.21566 1.4939 8.09246 1.49414 7.91488V1.7776C1.49414 1.56087 1.56479 1.37541 1.7061 1.2212C1.84741 1.067 2.01707 0.989765 2.2151 0.989502H7.98273C8.18099 0.989502 8.35077 1.06674 8.49208 1.2212C8.63339 1.37567 8.70392 1.56113 8.70368 1.7776V6.50616C8.70368 6.72288 8.63315 6.90848 8.49208 7.06295C8.35101 7.21741 8.18123 7.29451 7.98273 7.29425H2.93605ZM2.62964 6.50616H7.98273V1.7776H2.2151V6.94946L2.62964 6.50616Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2133_24723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.65145,
    height: 9.45713,
    fill: "white",
    transform: "translate(0.772949 0.201416)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2133_24723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.65145,
    height: 9.45713,
    fill: "white",
    transform: "translate(0.772949 0.201416)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataIcon);
export default __webpack_public_path__ + "static/media/DataIcon.5750f4f3426cea5b404130d942dd986e.svg";
export { ForwardRef as ReactComponent };